import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { API } from '../constants/api.constant';
import { CustomHttpClientService } from './custom-http-client.service';
import { Perk } from '../models/app.model';

@Injectable({
  providedIn: 'root',
})
export class PointsService {
  constructor(private http: CustomHttpClientService) { }

  public refreshPoints$ = new BehaviorSubject<boolean>(false);
  private currentActivatedCards: Array<any> = null;
  private currentRedeemables: any = null;

  public filterRedeemCardList(list: Array<any>) {
    return list.filter(card => card.pointType !== 6);
  }

  public getMyCheckInDates(): Observable<any> {
    return this.http.get(API.PREFIX + API.GET_DAILY_CHECK_IN_DAYS).pipe(map((res: any) => res.result.signDates));
  }

  public dailyCheckIn(): Observable<any> {
    return this.http.post(API.PREFIX + API.DAILY_CHECK_IN, null).pipe(map((res: any) => res.result));
  }

  public getMyPoints(): Observable<any> {
    return this.http.get(API.PREFIX + API.GET_MY_CURRENT_POINTS).pipe(map((res: any) => res.result));
  }

  getRedeemables(): Observable<any> {
    // if (this.currentRedeemables) {
    //   return of(this.currentRedeemables);
    // }

    return this.http.get(API.PREFIX + API.GET_MY_POINTS, {
      headers: new HttpHeaders({ ignoreLoading: 'ignoreLoading' }),
    }).pipe(map((res: any) => {
      this.currentRedeemables = res.result;
      return this.currentRedeemables;
    }));
  }

  getPublicAvailRedeemables(): Observable<any> {
    return this.http.get(API.PREFIX + API.GET_AVAIL_REDEEMABLES, {
      headers: new HttpHeaders({ ignoreLoading: 'ignoreLoading' }),
    }).pipe(map((res: any) => res.result));
  }

  getActivatedCards(noHardReload = true): Observable<Array<any>> {
    if (this.currentActivatedCards && !noHardReload) {
      return of(this.currentActivatedCards);
    }

    return this.http.get(API.PREFIX + API.GET_ACTIVATED_CARDS, {
      headers: new HttpHeaders({ ignoreLoading: 'ignoreLoading' }),
    }).pipe(map((res: any) => res.result), map((res: Array<any>) => {
      this.currentActivatedCards = res.sort((a, b) => b.id - a.id);
      return this.currentActivatedCards;
    }));
  }

  getMyCardDetail(card): Observable<any> {
    return this.http.get(API.PREFIX + API.GET_MY_CARD_DETAIL + card.cardNumber).pipe(map((res: any) => res.result));
  }

  getMyCardBarcode(card): Observable<any> {
    return this.http.get(API.PREFIX + API.GET_CARD_BARCODE + card.barCode).pipe(map((res: any) => res.result));
  }

  redeemCard(card): Observable<any> {
    return this.http.post(API.PREFIX + API.REDEEM_CARDS, card).pipe(map((res: any) => res.result));
  }

  deleteCard(card): Observable<any> {
    return this.http.put(API.PREFIX + API.DELETE_CARD, { cardNumber: card.cardNumber });
  }

  getPerks(): Observable<Perk[]> {
    return this.http.get(API.PREFIX + API.GET_PERKS_LIST, {
    }).pipe(map((res: any) => res.result));
  }

  submitPerk(perk: Perk): Observable<any> {
    return this.http.post(API.PREFIX + API.SUBMIT_PERK, { perks_type: perk.perksType });
  }
}
